import { render, staticRenderFns } from "./scrollable-panel.vue?vue&type=template&id=207b0594"
import script from "./scrollable-panel.vue?vue&type=script&lang=js"
export * from "./scrollable-panel.vue?vue&type=script&lang=js"
import style0 from "./scrollable-panel.vue?vue&type=style&index=0&id=207b0594&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports